import { Checkbox } from '@/components/ui/atoms/Checkbox';

interface SendNotificationCheckboxProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/** Per-move opt-out for the stage email. Not persisted; stage automation is unchanged. */
export function SendNotificationCheckbox({
  id,
  label,
  checked,
  onChange,
  disabled = false,
}: SendNotificationCheckboxProps) {
  return (
    <div className="flex items-center gap-2">
      <Checkbox
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        aria-label={label}
        size="md"
      />
      <label
        htmlFor={id}
        className="text-sm font-body font-medium text-dark-invirtus cursor-pointer"
      >
        {label}
      </label>
    </div>
  );
}
